import * as React from "react";
import { useContext } from "react";

import { Divider, Box } from "@mui/material";
import { AppContext } from "../../contextProviders/AppContext";
import { add, set, addHours } from "date-fns";
import DateRange from "./Daterange";
import TimePickerComponent from "./TimePicker";
import { translation } from "../Dictionary";
import { Stack } from "@mui/system";

export default function DatePickerDesktop({
  startSliderValue,
  endSliderValue,
  dayStart,
  handleDateChange,
  startTime,
  endTime,
  SLIDER_STEP,
  setStartTime,
  selectedTimeFrame,
  throttle,
  setEndTime,
  contentHeigth,
  FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA,

  getMinimumDate,
  startTimeLabel,
  returnTimeLabel,
}) {
  const {
    language,
    dateRange,
    startDateString,
    endDateString,
    selectedCompany,
    hasError,
    endTimeOk,
    selectedDateRange,
    FEATURE_FIXED_RESERVATION_TIMEFRAME,
    selectedPicker,
    setSelectedPicker,
    setSelectedDateRange,
    FEATURE_NO_TIME_SELECT,
  } = useContext(AppContext);

  return (
    <Box
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        transition: "ease-in-out 150ms",
        display: "flex",
        flexDirection: "row",
        width: "60%",
      }}
    >
      <Divider orientation="vertical" flexItem variant="middle" />
      <Box sx={{ width: FEATURE_NO_TIME_SELECT ? "100%" : "60%" }}>
        <DateRange
          getMinimumDate={getMinimumDate}
          contentHeigth={contentHeigth}
          selectedPicker={selectedPicker}
          setSelectedPicker={setSelectedPicker}
          selectedDateRange={selectedDateRange}
          handleDateChange={handleDateChange}
          setSelectedDateRange={setSelectedDateRange}
          selectedCompany={selectedCompany}
          endTimeOk={endTimeOk}
          FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA={
            FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA
          }
        />
      </Box>
      <Divider orientation="vertical" variant="middle" flexItem />

      {!FEATURE_NO_TIME_SELECT && (
        <Stack
          direction={"row"}
          sx={{ width: "45%", justifyContent: "space-evenly" }}
        >
          <Box sx={{ width: "40%" }}>
            <TimePickerComponent
              contentHeigth={contentHeigth}
              selectedPicker={selectedPicker}
              setSelectedPicker={setSelectedPicker}
              hasError={hasError}
              endTimeOk={endTimeOk}
              type={"startTime"}
              selectedDateRange={selectedDateRange}
              title={startTimeLabel}
              dateString={startDateString}
              timeValue={startTime}
              sliderValue={startSliderValue}
              SLIDER_STEP={SLIDER_STEP}
              dayStart={dayStart}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
              selectedTimeFrame={selectedTimeFrame}
              FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA={
                FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA
              }
              FEATURE_FIXED_RESERVATION_TIMEFRAME={
                FEATURE_FIXED_RESERVATION_TIMEFRAME
              }
              onChange={setStartTime}
              onChangeSlider={throttle((_, v) => {
                const minutes = v * SLIDER_STEP;
                const time = add(dayStart, { minutes });
                setStartTime(
                  set(selectedDateRange[0], {
                    hours: time.getHours(),
                    minutes: time.getMinutes(),
                  })
                );
                if (FEATURE_FIXED_RESERVATION_TIMEFRAME) {
                  setEndTime(addHours(startTime, selectedTimeFrame));
                }
              }, 100)}
            />
          </Box>

          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ marginLeft: "10px", marginRight: "10px" }}
          />
          <Box sx={{ width: "40%" }}>
            <TimePickerComponent
              contentHeigth={contentHeigth}
              selectedPicker={selectedPicker}
              setSelectedPicker={setSelectedPicker}
              dateRange={dateRange}
              hasError={hasError}
              endTimeOk={endTimeOk}
              selectedDateRange={selectedDateRange}
              type={"returnTime"}
              title={returnTimeLabel}
              dateString={endDateString}
              timeValue={endTime}
              sliderValue={endSliderValue}
              SLIDER_STEP={SLIDER_STEP}
              dayStart={dayStart}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
              selectedTimeFrame={selectedTimeFrame}
              FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA={
                FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA
              }
              FEATURE_FIXED_RESERVATION_TIMEFRAME={
                FEATURE_FIXED_RESERVATION_TIMEFRAME
              }
              onChange={(time) => {
                setEndTime(time);
              }}
              onChangeSlider={throttle((_, v) => {
                const minutes = v * SLIDER_STEP;
                const time = add(dayStart, { minutes });
                setEndTime(
                  set(selectedDateRange[1], {
                    hours: time.getHours(),
                    minutes: time.getMinutes(),
                  })
                );
                if (FEATURE_FIXED_RESERVATION_TIMEFRAME) {
                  setEndTime(addHours(startTime, selectedTimeFrame));
                }
              }, 100)}
            />
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ marginLeft: "10px", marginRight: "10px" }}
          />
        </Stack>
      )}
    </Box>
  );
}
